<template>
  <div v-if="hasResult" class="border-b border-black-30 sm:border-none">
    <div class="flex flex-col">
      <div
        class="fs-24 font-medium sm:px-6 search-result flex-1 flex items-center pr-4"
      >
        <slot v-if="isLoading" name="summary" />
        <h1 v-else v-html="summary"></h1>
      </div>

      <div class="flex flex-row">
        <div class="mdsm:hidden inline-flex items-center my-6">
          <label class="mr-2 inline-block font-medium">Sort by:</label>
          <custom-select
            class="ranking-dropdown"
            v-model="sortBy"
            placeholder="Sort By"
            :options="sortOptions"
          />
        </div>

        <div class="mdsm:hidden inline-flex items-center my-6 ml-8">
          <label class="mr-2 inline-block font-medium">View by:</label>
          <custom-select
            class="ranking-dropdown"
            v-model="viewBy"
            placeholder="View By"
            :options="viewOptions"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapGetters } from "vuex";
import { getLocation } from "../../helpers/searchHelpers";
import CustomSelect from "../../components/core/CustomSelect";

export default {
  components: {
    CustomSelect,
  },
  data() {
    return {
      sortOptions: [
        {
          label: "Special offers",
          value: "special-offers",
          class: "text-purple",
        },
        { label: "Price (lowest first)", value: "price" },
        { label: "Top Rated", value: "top-rated" },
      ],
      viewOptions: [
        { label: "Boats", value: "boats" },
        { label: "Departure date", value: "dates" },
      ],
    };
  },
  computed: {
    ...mapState(["ranking", "isLoading", "view"]),
    ...mapGetters(["sortedResults", "allTrips", "tripsBydates"]),
    sortBy: {
      get() {
        return this.ranking;
      },
      set(val) {
        this.setRanking(val);
        this.setPage(1);
      },
    },
    viewBy: {
      get() {
        return this.view;
      },
      set(val) {
        if (val === "dates") {
          this.setRanking("price");
        }
        this.setView(val);
        this.setPage(1);
      },
    },
    summary() {
      if (this.view === "boats") {
        if (this.sortedResults.length === 1) {
          return `1 liveaboard in ${getLocation(window.zubluDestination)}`;
        }

        return `${this.sortedResults.length} liveaboards in ${getLocation(
          window.zubluDestination
        )}`;
      } else {
        if (this.allTrips.length === 1) {
          return `1 itinerary found`;
        }

        return `${this.allTrips.length} itineraries found`;
      }
    },
    hasResult() {
      if (this.view === "boats") {
        return this.sortedResults.length > 0;
      } else {
        return this.tripsBydates.length > 0;
      }
    },
  },
  methods: {
    ...mapMutations(["setRanking", "setPage", "setView"]),
  },
};
</script>
